'use strict';

import './MessageBar.less';

const CKImage = require('ck-core-client/source/ui/image');
const Component = require('ck-core-client/source/ui/Component');

module.exports = Component.define({
	type: 'MessageBar',

	init_ui: function(type, content, image, button) {
		this.dom = $('<div class="messageBar">')
			.addClass(type)
			.append($('<div class="content">').append(content));
		if (image) {
			this.dom.prepend(CKImage(image));
		}

		if (button) {
			this.dom.prepend(button.dom);
		}
	}
});
